import { useStore, createStore } from 'zustand';
import { persist } from 'zustand/middleware';

const initState = {
  id: '',
  name: '',
  imageUrl: '',
  permissions: [],
  accessToken: '',
  lastPostTime: 0,
};

export const userStore = createStore(
  persist(
    (set) => ({
      ...initState,
      setUser: (user) => set(() => ({ ...user })),
      resetUser: async () => {
        set(initState);
      },
      setLastPostTime: (time) => set(() => ({ lastPostTime: time })),
    }),
    {
      name: 'citylife_store',
    },
  ),
);

export const useUserStore = () => useStore(userStore);
